import CurrencyFormatter from "currency-formatter"

export default class Formatter {
    static toBrazilianCurrency(value) {
       return CurrencyFormatter.format(value, { code: "BRL", symbol: "", precision: 0})
    }
}
